module.exports = __webpack_public_path__ + "static/media/nexus-design.943f4b38.png";